import { render } from "./Home.vue?vue&type=template&id=ccaa20b4&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=ccaa20b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ccaa20b4"

export default script